import {
    STOCK_TAKING_CAR_MANAGEMENT_DETAILS_BEGIN,
    STOCK_TAKING_CAR_MANAGEMENT_DETAILS_FAILURE,
    STOCK_TAKING_CAR_MANAGEMENT_DETAILS_SUCCESS
  } from '../constants'
  
  export function reducer(state, action) {
    switch (action.type) {
      case STOCK_TAKING_CAR_MANAGEMENT_DETAILS_BEGIN:
        return {
          takingCarManagement: {
            ...state.takingCarManagement,
          }
        }
      case STOCK_TAKING_CAR_MANAGEMENT_DETAILS_SUCCESS:
        return {
          takingCarManagement: {
            ...state.takingCarManagement,
            currentTakingCar: action.data
          }
        }
      case STOCK_TAKING_CAR_MANAGEMENT_DETAILS_FAILURE:
        return {
          takingCarManagement: {
            ...state.takingCarManagement,
          }
        }
      default:
        return state
    }
  }
  